import { Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { EventMessage, EventType, AuthenticationResult } from '@azure/msal-browser';
import { filter } from 'rxjs';
import { HeaderService } from '../../services/header.service';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HeaderComponent implements OnInit {


  currentShowDropdown: boolean = false;
  showSubSubMenu: boolean = false;
  userLogin: any;
  ControlSystemsName: string | null = '';
  ControlSystemsId: string | null = '';
  menuItems: MenuItem[] = [
    {
      label: 'Logout',
      icon: 'pi pi-sign-out',
      command: () => this.logout()
    }
  ];
  menuTop = 0;
  menuRight = 8;

  get userInitials(): string {
    const localPart = typeof this.userLogin === 'string' ? this.userLogin.trim().split('@')[0] : '';
    const nameParts = localPart.split(/[._\s-]+/).filter(Boolean);

    if (!nameParts.length) {
      return '?';
    }

    const firstInitial = nameParts[0].charAt(0);
    const lastInitial = nameParts.length > 1 ? nameParts[nameParts.length - 1].charAt(0) : '';
    return (firstInitial + lastInitial).toUpperCase();
  }

  constructor(
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private headerService: HeaderService,

  ) {


  }

  ngOnInit() {
    this.headerService.reciveControlSystemsNameObservable.subscribe(ControlSystemsName => {


      this.ControlSystemsName = sessionStorage.getItem('ControlSystemsName') ?? '';
    });
    this.headerService.reciveControlSystemsIdObservable.subscribe(ControlSystemsName => {

      this.ControlSystemsId = sessionStorage.getItem('ControlSystemsId') ?? '';
    });
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) =>
          msg.eventType === EventType.LOGIN_SUCCESS ||
          msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
          msg.eventType === EventType.SSO_SILENT_SUCCESS
        ),
      )
      .subscribe((result: EventMessage) => {
        const payload = (result as any).payload;
        if (payload?.account?.username) {
          this.userLogin = payload.account.username;
          sessionStorage.setItem('username', this.userLogin);
        }
      });

    this.userLogin = sessionStorage.getItem('username');



  }

  @ViewChild('profileMenu') profileMenu!: ElementRef;
  @ViewChild('profileButton') profileButton!: ElementRef;

  toggleDropdown() {
    this.currentShowDropdown = !this.currentShowDropdown;

    if (this.currentShowDropdown) {
      const rect = this.profileButton.nativeElement.getBoundingClientRect();
      this.menuTop = rect.bottom + 0;
      this.menuRight = window.innerWidth - rect.right;
    }
  }
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    const clickedInsideMenu = this.profileMenu?.nativeElement.contains(event.target);
    const clickedButton = this.profileButton?.nativeElement.contains(event.target);

    if (!clickedInsideMenu && !clickedButton) {
      this.currentShowDropdown = false;
    }
  }



  logout() {

    this.authService.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
    sessionStorage.clear();

  }


}



